import React, { useEffect, useState, useMemo } from "react";
import { Button } from "react-bootstrap";
import { FiMoon, FiSun } from "react-icons/fi";
import { screenButtons } from "./ctiData";
import { getScreenButtonClass } from "./ctiHelpers";

function NavBar({
  screen,
  onScreenChange,
  statusMeta,
  theme,
  onToggleTheme,
  userData,
}) {
  const profiles = userData?.agentData?.agentTelephony?.profile || [];
  const extension = profiles.find((p) => p.type === "WEBRTC")?.number?.number || profiles.find((p) => p.type === "Soft Phone")?.number?.number;
  const [webrtcStatus, setWebrtcStatus] = useState(null);
  
  useEffect(() => {
    const interval = setInterval(() => {
      const status = sessionStorage.getItem("webrtcPhoneStatus");
      setWebrtcStatus(status);
    }, 1000);
  
    return () => clearInterval(interval);
  }, []);
  
  const parsedStatus = useMemo(() => {
    if (!webrtcStatus)
      return {
        success: false,
        code: "DISCONNECTED",
        message: "Dialer is Disconnected",
      };
  
    if (!webrtcStatus.includes("-")) {
      return {
        success: true,
        code: "READY",
        message: "Dialer connected",
      };
    }
  
    const [code, message] = webrtcStatus.split("-");
  
    return {
      success: false,
      code: code || "ERROR",
      message: message || "Connection error",
    };
  }, [webrtcStatus]);
  return (
    <div className="nav-bar">
      {/* <span className="nav-logo">NEXUS CTI</span> */}
      {screenButtons.map((btn) => {
        const isDisabled = btn.key !== "idle" && !parsedStatus?.success;
        return (
          <Button
            key={btn.key}
            disabled={isDisabled}
            className={[
              "screen-btn",
              getScreenButtonClass(btn.key, screen),
              isDisabled ? "opacity-50 cursor-not-allowed" : "",
            ]
            .join(" ")
            .trim()}
            onClick={() => {
              if (!isDisabled) onScreenChange(btn.key);
            }}
          >
            {btn.label}
          </Button>
        );
      })}
      <div className="spacer" />
      <div className="agent-badge">
        {/* <div className={`agent-dot ${statusMeta.dotClass}`} /> */}
        <button
          type="button"
          className="theme-toggle"
          onClick={onToggleTheme}
          aria-label={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
        >
          {theme === "light" ? <FiMoon /> : <FiSun />}
        </button>
        <span className="agent-name">
          {userData?.agentData?.agent_name || "UNKNOWN"}
        </span>
        {extension && (
          <>
            <span className="divider">|</span>
            <span className="agent-ext">Ext. {extension}</span>
          </>
        )}
      </div>
    </div>
  );
}

export default React.memo(NavBar);
